// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  EchoHTTPError,
  HandlersGraphEngineInternalResponse,
  HandlersPatchGraphEngineInternalRequest,
  HandlersPatchGraphEnginesInternalRequest,
  HandlersPatchGraphEnginesInternalResponse,
} from '../models/index';
import {
  EchoHTTPErrorFromJSON,
  EchoHTTPErrorToJSON,
  HandlersGraphEngineInternalResponseFromJSON,
  HandlersGraphEngineInternalResponseToJSON,
  HandlersPatchGraphEngineInternalRequestFromJSON,
  HandlersPatchGraphEngineInternalRequestToJSON,
  HandlersPatchGraphEnginesInternalRequestFromJSON,
  HandlersPatchGraphEnginesInternalRequestToJSON,
  HandlersPatchGraphEnginesInternalResponseFromJSON,
  HandlersPatchGraphEnginesInternalResponseToJSON,
} from '../models/index';

export interface GetGraphEnginePortalRequest {
  id: string;
  includeDataModel?: boolean;
}

export interface ListGraphEnginesInternalRequest {
  showDeleted?: boolean;
}

export interface PatchGraphEngineInternalRequest {
  id: string;
  request: HandlersPatchGraphEngineInternalRequest;
}

export interface PatchGraphEnginesInternalRequest {
  request: HandlersPatchGraphEnginesInternalRequest;
}

/**
 *
 */
export class InternalGraphEnginesApi extends runtime.BaseAPI {
  /**
   * Internal lookup of a graph engine - bypasses project filtering and includes soft-deleted engines. For deleted engines the raw database record is returned; otherwise the k8s status is merged in.
   * Get graph engine by ID (internal)
   */
  async getGraphEnginePortalRaw(
    requestParameters: GetGraphEnginePortalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlersGraphEngineInternalResponse>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling getGraphEnginePortal().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['includeDataModel'] != null) {
      queryParameters['includeDataModel'] =
        requestParameters['includeDataModel'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/v1/portal/graph-engines/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlersGraphEngineInternalResponseFromJSON(jsonValue),
    );
  }

  /**
   * Internal lookup of a graph engine - bypasses project filtering and includes soft-deleted engines. For deleted engines the raw database record is returned; otherwise the k8s status is merged in.
   * Get graph engine by ID (internal)
   */
  async getGraphEnginePortal(
    requestParameters: GetGraphEnginePortalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlersGraphEngineInternalResponse> {
    const response = await this.getGraphEnginePortalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Internal listing of graph engines - bypasses project filtering. Optionally includes soft-deleted engines.
   * List graph engines (internal)
   */
  async listGraphEnginesInternalRaw(
    requestParameters: ListGraphEnginesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<HandlersGraphEngineInternalResponse>>> {
    const queryParameters: any = {};

    if (requestParameters['showDeleted'] != null) {
      queryParameters['showDeleted'] = requestParameters['showDeleted'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/internal/v1/portal/graph-engines`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(HandlersGraphEngineInternalResponseFromJSON),
    );
  }

  /**
   * Internal listing of graph engines - bypasses project filtering. Optionally includes soft-deleted engines.
   * List graph engines (internal)
   */
  async listGraphEnginesInternal(
    requestParameters: ListGraphEnginesInternalRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<HandlersGraphEngineInternalResponse>> {
    const response = await this.listGraphEnginesInternalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Patches GraphEngine CR spec (memory and/or neo4jVersion). Bypasses project filtering; not exposed on the public API. At least one field is required.
   * Patch graph engine spec (internal)
   */
  async patchGraphEngineInternalRaw(
    requestParameters: PatchGraphEngineInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling patchGraphEngineInternal().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling patchGraphEngineInternal().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/internal/v1/portal/graph-engines/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: HandlersPatchGraphEngineInternalRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Patches GraphEngine CR spec (memory and/or neo4jVersion). Bypasses project filtering; not exposed on the public API. At least one field is required.
   * Patch graph engine spec (internal)
   */
  async patchGraphEngineInternal(
    requestParameters: PatchGraphEngineInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.patchGraphEngineInternalRaw(requestParameters, initOverrides);
  }

  /**
   * Patches GraphEngine CR spec (memory and/or neo4jVersion) for multiple engines. Bypasses project filtering; not exposed on the public API. At least one patch field and one engine id are required. Returns per-engine results.
   * Patch multiple graph engine specs (internal)
   */
  async patchGraphEnginesInternalRaw(
    requestParameters: PatchGraphEnginesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlersPatchGraphEnginesInternalResponse>> {
    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling patchGraphEnginesInternal().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/internal/v1/portal/graph-engines/batch`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: HandlersPatchGraphEnginesInternalRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlersPatchGraphEnginesInternalResponseFromJSON(jsonValue),
    );
  }

  /**
   * Patches GraphEngine CR spec (memory and/or neo4jVersion) for multiple engines. Bypasses project filtering; not exposed on the public API. At least one patch field and one engine id are required. Returns per-engine results.
   * Patch multiple graph engine specs (internal)
   */
  async patchGraphEnginesInternal(
    requestParameters: PatchGraphEnginesInternalRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlersPatchGraphEnginesInternalResponse> {
    const response = await this.patchGraphEnginesInternalRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
